export const it = {
  returnLineItems: {
    refund: "Rimborso/i",
    exchange: "Cambio/i",
    discount: "Sconto/i",
  },
  returnStoreAddress: {
    mapButton: "Vedi sulla mappa",
  },
  returnRequestDate: {
    label: "La tua richiesta di reso è stata effettuata il {{date}} alle {{time}}",
  },
  actions: {
    continue: "Continua",
  },
  "order-identification": {
    title: "Traccia il tuo ordine",
    description:
      "Inserisci i dettagli del tuo ordine per tracciare il tuo pacco",
    fields: {
      "zip-code": {
        title: "Codice postale",
        description: "Inserisci il tuo codice postale di consegna",
        required: "Il codice postale è obbligatorio",
      },
      email: {
        title: "Indirizzo email",
        description: "Inserisci l'indirizzo email utilizzato per il tuo ordine",
        required: "L'indirizzo email è obbligatorio",
      },
      "tracking-number": {
        title: "Numero d'ordine",
        description: "Inserisci il tuo numero d'ordine",
        required: "Il numero d'ordine è obbligatorio",
      },
    },
    errors: {
      "unknown-order": {
        title: "Numero d'ordine sconosciuto",
        description:
          "Il numero d'ordine non è stato trovato, si prega di verificarlo",
      },
      "search-error": {
        title: "Errore di ricerca",
        description:
          "Non siamo riusciti a trovare l'ordine. Riprova più tardi.",
      },
    },
  },
  delivery: "Consegna",
  "parcel-history": "Cronologia del pacco",
  "order-details": {
    title: "Dettagli dell'ordine",
    "tracking-number": "Numero di tracciamento",
    "order-number": "Numero d'ordine",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Data di consegna stimata",
      deliveredOn: "Consegnato il",
      from: "dal",
      to: "al",
    },
  },
  deliveryAddress: {
    title: "Indirizzo di consegna:",
    titlePickup: "Indirizzo del punto di ritiro:",
    orderDetails: {
      title: "Dettagli dell'ordine:",
      trackingNumber: "Numero di tracciamento:",
      orderNumber: "Numero d'ordine:",
      orderDate: "Data dell'ordine:",
    },
  },
  pickupPoint: {
    title: "Punto di ritiro",
    openingHours: "Orari di apertura:",
    closed: "Chiuso",
    directions: "Indicazioni",
    days: {
      monday: "Lunedì:",
      tuesday: "Martedì:",
      wednesday: "Mercoledì:",
      thursday: "Giovedì:",
      friday: "Venerdì:",
      saturday: "Sabato:",
      sunday: "Domenica:",
    },
  },
  wallet: {
    warningNotEnabled:
      "È necessario abilitare Wallet nelle impostazioni del negozio",
  },
  crossSell: {
    youMightAlsoLike: "Potrebbe piacerti anche",
  },
  "rate-order": {
    "order-recap": {
      title: "Il tuo ordine",
      "tracking-label": "Numero di tracciamento:",
      "order-label": "Numero d'ordine:",
    },
    form: {
      title: "Valuta la tua consegna",
      "rating-label": "Valuta la tua esperienza di consegna",
      "comment-label": "Commento (facoltativo)",
      "comment-placeholder": "Condividi la tua esperienza con noi…",
      "submit-cta": "Invia la mia valutazione",
      "update-cta": "Aggiorna la mia valutazione",
      "rating-required": "Seleziona una valutazione.",
    },
    "thank-you": {
      title: "Grazie per il tuo feedback!",
      description:
        "La tua valutazione è stata salvata. Ci aiuterà a migliorare l'esperienza di consegna.",
    },
    errors: {
      "invalid-token": {
        title: "Link non valido o scaduto",
        description:
          "Questo link non è più valido. Riaprilo dalla tua ultima email di tracciamento.",
      },
      submit: {
        title: "Qualcosa è andato storto",
        description:
          "Non siamo riusciti a salvare la tua valutazione. Riprova più tardi.",
      },
    },
  },
  shippingInstructions: {
    colissimo:
      "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Colissimo più vicino.",
    chronoShop2Shop:
      "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Chronopost più vicino.",
    ups: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto UPS più vicino.",
    customerCarrier:
      "Puoi ora spedire il tuo pacco di reso con il corriere di tua scelta.",
    merchantCarrier:
      "Ti invieremo un'etichetta di reso via email entro 1–3 giorni lavorativi.",
    returnToStore:
      "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel negozio più vicino.",
    malca:
      "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto Malca più vicino.",
    tnt: "Puoi ora stampare la tua etichetta di reso e consegnare il pacco nel punto TNT più vicino.",
    bonDeRetour:
      "Il tuo modulo di reso è pronto. Puoi stamparlo ora e usarlo per il tuo reso.",
  },
  downloadLabel: {
    label: "Scarica la mia etichetta",
    bonDeRetour: "Scarica il mio modulo di reso",
  },
  shippingInstructionsTitle: {
    shippingLabel: "La tua etichetta di spedizione è pronta",
    bonDeRetour: "Il tuo modulo di reso è pronto",
  },
} as const;
